export function plural(value, one, few, many) {
  const lastDigit = value % 10
  const prevDigit = Math.floor(value / 10) % 10
  if (prevDigit === 1) return many
  if (lastDigit === 1) return one
  if (lastDigit >= 2 && lastDigit <= 4) return few
  return many
}
